export const SUSPEND_MASTER_COMMUNICATION = 'SUSPEND_MASTER_COMMUNICATION';
export const AUTHENTICATION = 'AUTHENTICATION';
export const START_PROGRAMMING = 'START_PROGRAMMING';
export const END_PROGRAMMING = 'END_PROGRAMMING';
export const PROGRAMMING = 'PROGRAMMING';
